import React, { useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import './SimpleProcess.css';

const SimpleProcess = () => {
  const { t } = useTranslation();
  const sectionRef = useRef(null);
  const titleRef = useRef(null);
  const descriptionRef = useRef(null);
  const stepsRef = useRef(null);
  
  // Animation on scroll
  useEffect(() => {
    const section = sectionRef.current;
    const title = titleRef.current;
    const description = descriptionRef.current;
    const steps = stepsRef.current;
    
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          section.classList.add('visible');
          setTimeout(() => title.classList.add('visible'), 200);
          setTimeout(() => description.classList.add('visible'), 400);
          setTimeout(() => steps.classList.add('visible'), 600);
          
          // Animate step items with staggered delay
          const stepItems = steps.querySelectorAll('.process-step');
          stepItems.forEach((item, index) => {
            setTimeout(() => item.classList.add('visible'), 600 + (index * 200));
          });
          
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.2 });
    
    if (section) {
      observer.observe(section);
    }
    
    return () => {
      if (section) {
        observer.unobserve(section);
      }
    };
  }, []);

  return (
    <section className="simple-process process-section" ref={sectionRef}>
      <div className="simple-process-background">
        <div className="simple-process-shape simple-process-shape-1"></div>
        <div className="simple-process-shape simple-process-shape-2"></div>
      </div>
      
      <div className="container">
        <div className="simple-process-content">
          <h2 className="simple-process-title" ref={titleRef}>
            {t('simpleProcessTitle')}
          </h2>
          
          <p className="simple-process-description" ref={descriptionRef}>
            {t('simpleProcessDescription')}
          </p>
          
          <div className="simple-process-steps" ref={stepsRef}>
            <div className="process-step">
              <div className="process-step-content">
                <div className="process-step-number">01</div>
                <h3 className="process-step-title">{t('simpleProcessStep1').split(':')[1]}</h3>
              </div>
              <div className="process-step-connector"></div>
            </div>
            
            <div className="process-step">
              <div className="process-step-content">
                <div className="process-step-number">02</div>
                <h3 className="process-step-title">{t('simpleProcessStep2').split(':')[1]}</h3>
              </div>
              <div className="process-step-connector"></div>
            </div>
            
            <div className="process-step">
              <div className="process-step-content">
                <div className="process-step-number">03</div>
                <h3 className="process-step-title">{t('simpleProcessStep3').split(':')[1]}</h3>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default SimpleProcess;
